import React, { useState } from 'react';
import { FiWifiOff, FiRefreshCw } from 'react-icons/fi';

const ConnectionError = ({ onRetry }) => {
  const [isRetrying, setIsRetrying] = useState(false);

  const handleRetry = async () => {
    setIsRetrying(true);
    try {
      await onRetry();
    } finally {
      setIsRetrying(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
      {/* Backdrop with blur */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-md animate-in fade-in duration-200"></div>

      {/* Dialog */}
      <div className="relative w-full max-w-sm">
        {/* Outer glow effect */}
        <div className="absolute -inset-1 bg-gradient-to-r from-blue-500/20 via-indigo-500/20 to-blue-500/20 rounded-2xl blur-xl opacity-75 animate-pulse" style={{ animationDuration: '3s' }}></div>

        <div className="relative overflow-hidden bg-gradient-to-b from-gray-900/95 to-gray-950/95 backdrop-blur-xl rounded-2xl border border-blue-500/20 shadow-2xl animate-in zoom-in-95 slide-in-from-bottom-4 duration-300">
          {/* Subtle inner gradient */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-transparent to-indigo-500/5"></div>

          {/* Top accent line */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-px bg-gradient-to-r from-transparent via-blue-400/60 to-transparent"></div>

          {/* Content */}
          <div className="relative px-6 py-8 sm:px-8 sm:py-10">
            <div className="flex flex-col items-center text-center">
              {/* Icon with layered glow */}
              <div className="relative mb-5">
                <div className="absolute inset-0 bg-blue-400/20 blur-3xl rounded-full scale-150"></div>
                <div className="absolute inset-0 bg-indigo-400/10 blur-2xl rounded-full scale-125 animate-pulse" style={{ animationDuration: '2s' }}></div>
                <div className="relative w-16 h-16 sm:w-18 sm:h-18 rounded-2xl bg-gradient-to-br from-blue-500/20 to-indigo-500/10 border border-blue-400/30 flex items-center justify-center shadow-lg shadow-blue-500/10">
                  <FiWifiOff className="w-8 h-8 sm:w-9 sm:h-9 text-blue-400" />
                </div>
              </div>

              {/* Message */}
              <div className="space-y-2 mb-6">
                <h3 className="text-xl sm:text-2xl font-semibold tracking-tight bg-gradient-to-r from-blue-300 via-blue-400 to-indigo-400 bg-clip-text text-transparent">
                  Connection Lost
                </h3>
                <p className="text-sm text-zinc-400 leading-relaxed max-w-xs">
                  Unable to reach the server. Please check your connection and try again.
                </p>
              </div>

              {/* Retry button */}
              <button
                onClick={handleRetry}
                disabled={isRetrying}
                className="group relative px-6 py-2.5 bg-blue-500/10 hover:bg-blue-500/20 border border-blue-400/20 hover:border-blue-400/40 text-blue-400 font-medium text-sm rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400/50 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <span className="relative flex items-center gap-2">
                  <FiRefreshCw className={`w-4 h-4 ${isRetrying ? 'animate-spin' : ''}`} />
                  {isRetrying ? 'Retrying...' : 'Retry Connection'}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectionError;
